import { Dialog, DialogContent } from '@mui/material';
import { usePDFSlick } from '@pdfslick/react';
import '@pdfslick/react/dist/pdf_viewer.css';

import theme from 'styles/theme/theme';

import PDFNavigation from './PDFNavigation';

type PDFViewerAppProps = {
  pdfFilePath: string | ArrayBuffer;
  open: boolean;
  onClose: () => void;
};

export const SimplePDFViewer: React.FC<PDFViewerAppProps> = ({ pdfFilePath, open, onClose }) => {
  const { viewerRef, usePDFSlickStore, PDFSlickViewer } = usePDFSlick(pdfFilePath, {});

  return (
    <Dialog open={open} fullScreen onClose={onClose}>
      <DialogContent sx={{ bgcolor: theme('de').palette.grey[300] }}>
        <div className=" pdfSlick">
          <PDFSlickViewer {...{ viewerRef, usePDFSlickStore }} />
          <PDFNavigation onClose={onClose} {...{ usePDFSlickStore }} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SimplePDFViewer;
